import { useTranslation } from 'react-i18next';

import { PLATFORM_THEME_COLORS, Typography } from '@thinknet-gmbh/platform-common-ui';

import { JobAdDescriptionWrapper, InfoElement } from './job-ad-description.styles';

const JobAdDescription = ({
  advertisementDescription,
  neededSkills,
}: {
  advertisementDescription: string;
  neededSkills: string[];
}) => {
  const { t } = useTranslation('jobs');

  return (
    <JobAdDescriptionWrapper>
      <InfoElement>
        <Typography weight="bold">{`${t('jobs:labels.jobDescription')}:`}</Typography>
        <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
          {advertisementDescription || '-'}
        </Typography>
      </InfoElement>
      <div>
        {neededSkills.map((skill, index) => (
          <InfoElement key={index}>
            <Typography weight="bold">{`${t('jobs:labels.neededSkills')}:`}</Typography>
            <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>{skill || '-'}</Typography>
          </InfoElement>
        ))}
      </div>
    </JobAdDescriptionWrapper>
  );
};

export default JobAdDescription;
